import { render, staticRenderFns } from "./Distribute.vue?vue&type=template&id=269bddef&scoped=true"
import script from "./Distribute.vue?vue&type=script&lang=js"
export * from "./Distribute.vue?vue&type=script&lang=js"
import style0 from "./Distribute.vue?vue&type=style&index=0&id=269bddef&prod&lang=scss&scoped=true"
import style1 from "./Distribute.vue?vue&type=style&index=1&id=269bddef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269bddef",
  null
  
)

export default component.exports